import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

interface StyledQrCodeProps {
	value: string;
	height?: string;
	width?: string;
}

export default function StyledQrCode({ value, height, width }: StyledQrCodeProps) {
	return (
		<div className="qr-outer">
			<div className="qr-inner">
				{/* Inline style is only way to set qr code size */}
				<QRCodeSVG value={value} style={{ height: height ?? '10rem', width: width ?? '10rem' }} />
			</div>
		</div>
	);
}
